module.exports = __webpack_public_path__ + "Roboto-MediumItalic.eb65fb18d4446e4ac27d.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-MediumItalic.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-MediumItalic.svg
// module chunks = styles